import React, { useEffect, Fragment } from "react";
import { Grid, CircularProgress, Typography } from "@material-ui/core";

import "./styles/style.css";

// import TableDirecciones from "../components/Tables/TableDirecciones/TableDirecciones";
import FormDirecciones from "../components/forms/Direcciones/Direcciones";
// import TableCancelaciones from "../../components/Tables/TableCancelaciones/TableCancelaciones";
// import TableRecolecciones from "../../components/Tables/TableRecolecciones/TableRecolecciones";
import useGetDestinatarios from "../hooks/destinatarios/useGetDestinatarios";

import usePostDirecciones from "../hooks/direcciones/usePostDirecciones";
import useGetDirecciones from "../hooks/direcciones/useGetDirecciones";
import usePatchDirecciones from "../hooks/direcciones/usePatchDirecciones";
import useDeleteDirecciones from "../hooks/direcciones/useDeleteDirecciones";

import usePostDestinatarios from "../hooks/destinatarios/usePostDestinatarios";
import usePatchDestinatarios from "../hooks/destinatarios/usePatchDestinatarios"
import useDeleteDestinatarios from "../hooks/destinatarios/useDeleteDestinatarios"

import MainDireccionesCards from "../components/Cards/MainDireccionesCards";

const Direcciones = () => {
  //const classes = useStyles();

  /*Metodos de solicitud de datos al servidor */
  //Direccciones
  const [{ data: update ,isLoading: cargarActualizacion}, doPost] = usePostDirecciones();
  const [{ data: destinatarios, isLoading: isDestinatariosLoading },getDestinatarios] = useGetDestinatarios();
  const [{ data: direcciones, isLoading: isDireccionesLoading },doGet] = useGetDirecciones("");
  const [{ data: patch }, doPatch] = usePatchDirecciones();
  const [{ data: deleted, isLoading:isBorradoLoading }, doDelete] = useDeleteDirecciones();

  //Destinatarios
  const [{ data: updateDestinatario }] = usePostDestinatarios();
  const [{ data: patchDestinatario }, doPatchDestinatario] = usePatchDestinatarios() ;
  const [{ data: deletedDestinatario }, doDeleteDestinataio] = useDeleteDestinatarios();
  /**Cada que se llamen los metodos se hace el get de informacion */
  useEffect(() => {
    doGet(Math.random());
    getDestinatarios(Math.random());
    // console.log(direcciones);
  }, [doPost,patch,update,deleted,updateDestinatario,patchDestinatario,deletedDestinatario,doGet,getDestinatarios]);
 

  return isDireccionesLoading||cargarActualizacion || isDestinatariosLoading || isBorradoLoading? (
    <CircularProgress />
  ) : (
    // <Grid container spacing={5}>
    //   <TableDirecciones
    //     data={direcciones}
    //     onAdd={doPost}
    //     onUpdate={doPatch}
    //     onDelete={doDelete}
    //     destinatarios={destinatarios}
    //   />
    //   <Grid item>

    //   </Grid>
    // </Grid>
    direcciones.length===0?
      (<Fragment>
        <div style={{marginTop:"30px"}} >
          <Typography variant="h4" component="h2" align="center" style={{marginBottom:"20px"}}>
             Añadir Direcciones 
          </Typography>
         
          <FormDirecciones doPost={doPost} />
        </div>
        
        </Fragment> )
    :
      (<Fragment>
      <Typography variant="h4" component="h2" align="center" style={{marginBottom:"20px"}}>
          Direcciones 
        </Typography>
      <Grid style={{marginTop:"10px"}}   container spacing={7}>

        {
        direcciones.map(direccion=>{
          const des=destinatarios.filter((item)=>{
            return direccion.destinatario===item._id
          })
          const destinatario=des[0];
          return <MainDireccionesCards 
            key={direccion._id} 
            direccion={direccion}
            doPatch={doPatch}
            onDelete={doDelete}
            destinatario={destinatario}
            doPatchDestinatario={doPatchDestinatario}
            doDeleteDestinataio={doDeleteDestinataio}
            />
        })}
      </Grid>
      <Fragment>
      <div style={{marginTop:"30px"}} >
        <Typography variant="h4" component="h2" align="center" style={{marginBottom:"20px"}}>
           Añadir Direcciones 
        </Typography>
       
        <FormDirecciones doPost={doPost} />
      </div>
      
      </Fragment> 
      </Fragment>)
      
    
  );
};

export default Direcciones;
